<template>
    <div class="row mt-3">
        <div class="col-md-12 text-center">
            <a-pagination
                v-model="current"
                :total="total"
                @change="onPageChange"
                :pageSize="perPage"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: ["current", "total", "perPage"],
    methods: {
        onPageChange(page, perPage) {
            this.$emit("pageChanged", page);
        },
    },
};
</script>
